<template>
  <div class="view-container">
    <div class="tabs-wrapper">
      <a-row justify="start" type="flex" :gutter="22">
        <a-col :span="6">
          <a-input-search
            placeholder="请输入关键字"
            @search="onSearch"
            @change="onSearch"
            size="default"
            v-model="keyword"
          />
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px">
        <a-table
          :columns="columns"
          :rowKey="record => record.id"
          :dataSource="tableData"
          :bordered="true"
          :rowClassName="tableRowClass"
          :rowSelection="rowSelection"
          :pagination="pagination"
          @change="paginationChange"
        >
          <template slot="cell" slot-scope="text">
            <span
              v-html="formatContent(text, keyword)"
              class="cell-text"
            ></span>
          </template>
        </a-table>
      </a-row>
    </div>
  </div>
</template>

<script>
import { search } from '@/api/course/course-user'
import moment from 'moment'
export default {
  data() {
    return {
      columns: [],
      tableData: [],
      rowKeys: [],
      rowSelection: {
        onChange: selectedRowKeys => {
          this.rowKeys = selectedRowKeys
        }
      },
      pagination: {
        showSizeChanger: true,
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal: total => {
          return `共 ${total} 条数据`
        }
      },
      keyword: ''
    }
  },
  created() {
    this.columns = [
      {
        title: '姓名',
        dataIndex: 'name',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '手机号',
        dataIndex: 'phone',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '账号',
        dataIndex: 'username',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '头像',
        dataIndex: 'avatar',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '公司名称',
        dataIndex: 'company',
        scopedSlots: { customRender: 'cell' }
      },

      {
        title: '注册时间',
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return text && moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '上次更改时间',
        dataIndex: 'updatedAt',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return text && moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      let { keyword, pagination } = this
      keyword = keyword.trim()
      const page = pagination.current || pagination.defaultCurrent
      const size = pagination.size || pagination.defaultPageSize
      search({ keyword, page, size }).then(resp => {
        let { result: res } = resp
        this.tableData = res.rows
        pagination.total = res.total
        this.pagination = JSON.parse(JSON.stringify(pagination))
      })
    },
    paginationChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    },
    formatContent(text, keyword) {
      text = text || ''
      if (typeof text === 'number') {
        text = String(text)
      }
      return text.replace(
        new RegExp(keyword, 'g'),
        `<strong style="color: red;">${keyword}</strong>`
      )
    }
  }
}
</script>

<style></style>
